import axios from '../axios';
import type { ApiEnvelope, TermijnDto } from './types';

const API_URL = '/v1/owner/manpro/projects';

export const ownerTermijnService = {
  async getTermijns(projectId: string): Promise<TermijnDto[]> {
    const response = await axios.get<ApiEnvelope<TermijnDto[]>>(`${API_URL}/${projectId}/termijns`);
    // Assuming backend wraps arrays directly in content, or inside { data: [] }
    return Array.isArray(response.data.content) ? response.data.content : (response.data.content as any).data || [];
  },

  async submitPaymentProof(projectId: string, termijnId: string, formData: FormData): Promise<any> {
    const response = await axios.post<ApiEnvelope<any>>(`${API_URL}/${projectId}/termijns/${termijnId}/pay`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async reviewWork(projectId: string, termijnId: string, status: 'approved' | 'rejected'): Promise<any> {
    const response = await axios.post<ApiEnvelope<any>>(`${API_URL}/${projectId}/termijns/${termijnId}/review-work`, {
      status: status,
    });
    return response.data;
  },

  async getOfflinePaymentMethods(): Promise<any[]> {
    const response = await axios.get<ApiEnvelope<any>>('/v1/customer/offline-payment/methods', {
      params: { limit: 100, offset: 1 }
    });
    // Depending on backend pagination, it might be in content.data or just content
    return response.data.content?.data || response.data.content || [];
  },
};
